<template>
  <div>
    <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.13.0/css/all.min.css" integrity="sha256-h20CPZ0QyXlBuAw7A+KluUYx/3pK+c7lYEpqLTlxjYQ=" crossorigin="anonymous">
    
    <button @click="share" class="button button--yellow button__share">
      <img :src="`/sites/msd_gesundheit/themes/custom/melanoma/assets/quiz/fr/images/icons/share-icon.svg`" class="share-icon" alt="share" />
    </button>

    <ExternalModal :showing="SoMeModalShowing" @close="closeModal()">
      <div>
        <h2 v-html="$t('result.share.h2')"></h2>
        <p></p>
      </div>
      <div id="share-network-list" class="pt-4">
          <ShareNetwork
            v-for="network in networks"
            :network="network.network"
            :key="network.network"
            :style="{backgroundColor: network.color}"
            :url="sharing.url"
            :title="sharing.title"
            :description="sharing.description"
            :quote="sharing.quote"
            :hashtags="sharing.hashtags"
            :twitterUser="sharing.twitterUser"
          >
            <i :class="network.icon"></i>
            <span>{{ network.name }}</span>
          </ShareNetwork>
      </div>
    </ExternalModal>
  </div>
</template>

<script>
import ExternalModal from "./ExternalModal.vue";
import ShareNetwork from "vue-social-sharing/src/share-network";

export default {
  name: "SoMeShare",
  components: {
    ExternalModal,
    ShareNetwork
  },
  data() {
    return {
      SoMeModalShowing: false,
      sharing: {
        url: document.location.href,
        title: this.$t('result.share.title'),
        description: this.$t('result.share.description'),
      },
      networks: [
        { network: 'email', name: 'Email', icon: 'far fah fa-lg fa-envelope', color: '#333333' },
        { network: 'facebook', name: 'Facebook', icon: 'fab fah fa-lg fa-facebook-f', color: '#1877f2' },
        { network: 'twitter', name: 'Twitter', icon: 'fab fah fa-lg fa-twitter', color: '#1da1f2' },
      ]
    };
  },
  methods: {
    share() {
      this.SoMeModalShowing = true;
    },
    closeModal() {
      this.SoMeModalShowing = false;
    }
  },
};
</script>

<style scoped lang="scss">
h2 {
  font-size: 1.5rem;
  font-weight: 700;

  @media (min-width: 768px){
    font-size: 2rem;
  }
}

#share-network-list {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  max-width: 1000px;
  margin: auto;
}

a[class^="share-network-"] {
  flex: none;
  color: #FFFFFF;
  background-color: #333;
  border-radius: 3px;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  align-content: center;
  align-items: center;
  cursor: pointer;
  margin: 0 10px 10px 0;
  text-decoration: none;
}

a[class^="share-network-"] .fah {
  background-color: rgba(0, 0, 0, 0.2);
  padding: 10px;
  flex: 0 1 auto;
}

a[class^="share-network-"] span {
  padding: 0 10px;
  flex: 1 1;
  font-weight: 500;
}

a.share-network-twitter {
  background-color: #1da1f2;
}

a.share-network-fakeblock {
  background-color: #41b883;
}

.button__share {
  height: 100%;
}

.share-icon {
  min-width: 18px;
}

</style>
